(function () {
  const loadGalleryVideo = (item) => {
    const video = item && item.querySelector('video[data-deferred-video="banner-with-popup"]');
    if (!video) return;

    if (video.dataset.deferredVideoLoaded !== "true") {
      video.querySelectorAll("source[data-src]").forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute("data-src");
      });
      video.dataset.deferredVideoLoaded = "true";
      video.muted = true;
      video.load();
    }

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  };

  const pauseGalleryVideo = (item) => {
    const video = item && item.querySelector('video[data-deferred-video="banner-with-popup"]');
    if (video && !video.paused) video.pause();
  };

  const initCollapsibleContent = () => {
    $(".banner-with-popup__toggle")
      .unbind("click")
      .on("click", function () {
        const parent = $(this).parent();

        if (!parent.hasClass("active")) {
          parent
            .siblings(".banner-with-popup__item.active")
            .removeClass("active");
          parent.addClass("active");
          $(this)
            .closest(".banner-with-popup__items")
            .find(".banner-with-popup__answer")
            .stop()
            .slideUp(300);
          $(this).next().stop().slideDown(300);
        } else {
          parent.removeClass("active");
          $(this).next().stop().slideUp(300);
        }
      });
  };

  const initGallery = () => {
    if ($(".banner-with-popup").length > 0) {
      $(".banner-with-popup").each(function (index, item) {
        var images = $(this).find(".banner-with-popup__gallery--image-wrapper");
        const gallery = item.querySelector(".banner-with-popup__gallery");
        if (!gallery || gallery.dataset.visibilityObserved === "true") return;
        gallery.dataset.visibilityObserved = "true";

        const start = () => {
          if (gallery.classList.contains("observe-me")) {
            gallery.classList.add("is-inview");
            setTimeout(() => {
              gallery.classList.remove("is-inview");
              gallery.classList.remove("observe-me");
              startGallerySlideshow(images);
            }, 600);
          } else {
            startGallerySlideshow(images);
          }
        };

        if (!("IntersectionObserver" in window)) {
          start();
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            start();
          },
          { rootMargin: "200px 0px", threshold: 0.01 }
        );
        observer.observe(gallery);
      });
    }
  };

  const startGallerySlideshow = (images) => {
    const gallery = images.closest(".banner-with-popup__gallery").get(0);
    if (!gallery || gallery.dataset.videoGalleryInitialized === "true") return;
    gallery.dataset.videoGalleryInitialized = "true";

    const showItem = (index, fadeSpeed) => {
      const item = images.get(index);
      loadGalleryVideo(item);
      images.eq(index).fadeIn(fadeSpeed);
    };

    if (images.length > 1) {
      let speed =
        Number(images.closest(".banner-with-popup__gallery").data("speed")) *
        1000;
      let currentImageIndex = 0;
      let fadeSpeed = 1000; // Time for the crossfade effect (adjust as needed)

      // Initially show the first image
      showItem(currentImageIndex, fadeSpeed);

      // Start the slideshow
      var interval = setInterval(function () {
        let nextImageIndex = (currentImageIndex + 1) % images.length;

        // Crossfade: one fades in while the other fades out
        pauseGalleryVideo(images.get(currentImageIndex));
        images.eq(currentImageIndex).fadeOut(fadeSpeed);
        showItem(nextImageIndex, fadeSpeed);

        currentImageIndex = nextImageIndex;
      }, speed); // Change image every {speed} seconds (adjust as needed)
    } else if (images.length === 1) {
      showItem(0, 0);
    }
  };

  const initBannerWithPopup = () => {
    initCollapsibleContent();
    initGallery();
  };

  document.addEventListener("DOMContentLoaded", function () {
    initBannerWithPopup();

    document.addEventListener("shopify:section:load", function () {
      initBannerWithPopup();
    });
  });
})();
